import { RazorInputField, toast } from "../../../components/razor-reuse";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReuseModal from "../../../components/fragment/modal/ReuseModal";
import { validateEmail } from "../../../helper/helpers";
import RootState from "../../../redux/type";
import { createAdminUserInvite } from "../../../redux/users";
import {
  hasSpecialCharactersOrNumbers,
  reactSelectStyleTable,
} from "../../../utils/Helper";

interface myComponentProps {
  onClose?: () => void;
  onFinish?: () => void;
  visible?: boolean;
}

const AddNewUserModal = ({ onClose, visible, onFinish }: myComponentProps) => {
  const { all_roles_drop } = useSelector((state: RootState) => state.roles);
  const { loading_users } = useSelector((state: RootState) => state.users);
  const dispatch = useDispatch();

  type detailProps = {
    first_name: string;
    last_name: string;
    roles: string[];
    email: string;
    gender: any;
  };
  const [details, setDetails] = useState<detailProps>({
    first_name: "",
    last_name: "",
    roles: [],
    email: "",
    gender: "",
  });

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    const obj = { ...details, [name]: value };
    setDetails(obj);
  };

  const genderOptions = [
    { label: "Male", value: "male" },
    { label: "Female", value: "female" },
  ];

  const getListUserId = (list: any) => {
    if (list?.length > 0) {
      const newList = list?.map((chi: any) => chi?.id);
      return newList;
    }
  };

  const handleSubmit = async () => {
    if (!validateEmail(details?.email)) {
      toast.error("Invalid email address!", {
        theme: "colored",
      });
      return;
    }
    const obj = {
      ...details,
      roles: getListUserId(details?.roles),
      gender: details?.gender?.label,
    };
    const data = await dispatch(createAdminUserInvite(obj) as any);

    if (data?.payload?.data?.status) {
      setDetails({
        first_name: "",
        last_name: "",
        roles: [],
        email: "",
        gender: "",
      });
      onFinish && onFinish();
    }
  };

  return (
    <>
      <ReuseModal
        title="Add New Team Member"
        btnLabel="Send Invite"
        visible={visible}
        onClose={onClose}
        disable={
          !details?.email ||
          !details?.first_name ||
          !details?.last_name ||
          details?.roles?.length < 1 ||
          !details?.gender
        }
        loading={loading_users}
        onBtnClick={handleSubmit}
        classname="modal-add-user"
      >
        {/* input here */}
        <RazorInputField
          color="black-light"
          type="text"
          placeholder="Enter first name"
          label="First Name"
          style={{ position: "relative", zIndex: 1 }}
          name={`first_name`}
          value={details?.first_name}
          onChange={(e: any) => {
            if (hasSpecialCharactersOrNumbers(e.target.value)) {
              return;
            }
            handleChange(e);
          }}
        />
        {/* input here */}
        {/* input here */}
        <RazorInputField
          color="black-light"
          type="text"
          placeholder="Enter last name"
          label="Last Name"
          style={{ position: "relative", zIndex: 1 }}
          name={`last_name`}
          value={details?.last_name}
          onChange={(e: any) => {
            if (hasSpecialCharactersOrNumbers(e.target.value)) {
              return;
            }
            handleChange(e);
          }}
        />
        {/* input here */}
        {/* input here */}
        <RazorInputField
          color="black-light"
          type="email"
          placeholder="Enter email"
          label="Email"
          style={{ position: "relative", zIndex: 1 }}
          name={`email`}
          value={details?.email}
          onChange={handleChange}
        />
        {/* input here */}
        {/* input here */}
        <RazorInputField
          color="black-light"
          type="select"
          placeholder="Select gender"
          label="Select Gender"
          style={{ position: "relative", zIndex: 2 }}
          menuPlacement={`top`}
          selectOption={genderOptions}
          selectStyles={reactSelectStyleTable}
          value={details?.gender}
          onChange={(e: any) => {
            setDetails((prev) => {
              return { ...prev, gender: e };
            });
          }}
        />
        {/* input here */}
        {/* input here */}
        <RazorInputField
          color="black-light"
          type="select"
          placeholder="Select role(s)"
          label="Assign Role"
          style={{ position: "relative", zIndex: 3 }}
          menuPlacement={`top`}
          selectOption={all_roles_drop}
          multi
          selectStyles={reactSelectStyleTable}
          value={details?.roles}
          onChange={(e: any) => {
            setDetails((prev) => {
              return { ...prev, roles: e };
            });
          }}
        />
        {/* input here */}
      </ReuseModal>
    </>
  );
};

export default AddNewUserModal;
